import { defineStore } from 'pinia';
import { ptCheckinSubmit, ptInfo } from '@/api/wallet';

function defaultState() {
  return {
    info: {},
    loading: false,
    checking: false
  };
}

export const usePointsTaskStore = defineStore('points-task', {
  state: () => defaultState(),
  getters: {
    weekList: (state) => (Array.isArray(state.info?.checkInList) ? state.info.checkInList : []),
    pointsBalance: (state) => Number(state.info?.ptBalance ?? state.info?.ptAmount ?? 0),
    checkInTotalCount: (state) => Number(state.info?.checkInTotalCount ?? 0),
    canCheckIn(state) {
      const list = Array.isArray(state.info?.checkInList) ? state.info.checkInList : [];
      return list.some((item) => Number(item?.isToday) === 1 && Number(item?.isCheckIn) === 0);
    }
  },
  actions: {
    reset() {
      Object.assign(this, defaultState());
    },
    async fetch(address, config = {}) {
      if (!address) {
        this.reset();
        return this.info;
      }
      this.loading = true;
      try {
        const result = await ptInfo({ address }, config);
        this.info = result || {};
        return this.info;
      } finally {
        this.loading = false;
      }
    },
    async checkIn(address) {
      if (!address || this.checking) {
        return null;
      }
      this.checking = true;
      try {
        const result = await ptCheckinSubmit({ address });
        await this.fetch(address, { meta: { showLoading: false } });
        return result;
      } finally {
        this.checking = false;
      }
    }
  }
});
